import React from 'react';
import {isValidObject} from 'src/utilities/objectUtils';
import type {IFormFieldV2} from 'src/types/FormV2';
import {FormViewRowV2} from '../FormViewRow/FormViewRowV2';
export interface FormViewDateV2Props {
  field: IFormFieldV2;
  value: any;
}

export const FormViewDateV2: React.FC<FormViewDateV2Props> = ({
  field,
  value,
}) => {
  const displayValue = isValidObject(value) && value.label;
  const val = !value
    ? ''
    : displayValue
    ? String(displayValue).toShortDate()
    : String(value).toShortDate();

  return <FormViewRowV2 field={field} value={val} />;
};
